import { API } from "app/auth/base";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { openModalError } from "app/store/trackingApp/modalErrorSlice";

export const getComprovante = createAsyncThunk(
  "comprovantesApp/comprovantes/entregas/getComprovante",
  async (idPedido: number, { rejectWithValue, dispatch }) => {
    try {
      const response = await API.get(`/comprovante/pedido-online/${idPedido}`);
      if (response.data.status === "ERROR") {
        dispatch(
          openModalError({
            text: "Se certifique de que digitou o número corretamente. O padrão de busca são 9 dígitos e podem haver sequenciais de mais 2 dígitos.",
            title: "Comprovante não encontrado!",
            btnLabel: "Refazer busca",
          })
        );
        return {};
      }
      return { ...response.data, idPedido };
    } catch (err) {
      dispatch(
        openModalError({
          text: "Se certifique de que digitou o número corretamente. O padrão de busca são 9 dígitos e podem haver sequenciais de mais 2 dígitos.",
          title: "Comprovante não encontrado!",
          btnLabel: "Refazer busca",
        })
      );
      return rejectWithValue(err.data);
    }
  }
);
